<template>
  <!-- <v-app id="app" style="height:100%">
    <Menu v-if="$store.getters.isLoggedIn"/>
    <v-main id="mainContent" v-bind:class="{ isCollapse: $store.getters.isMenuCollabsed, isShown: !$store.getters.isLoggedIn  }">
      <router-view :clickHelp="clickHelpVar"/>
    <div id="footer">
      <Footer @clickHelp="clickHelp"/> 
    </div></v-main>
  </v-app> -->
  <v-app  id="app">
    <NavBar @searchClicked="searchClicked" v-if="$store.getters.isLoggedIn"  :updateNotis="updateNotis"/>
    <!-- <Menu v-if="$store.getters.isLoggedIn"/> -->
      <div id="mainContent" v-bind:class="{ isCollapse: $store.getters.isMenuCollabsed, isShown: !$store.getters.isLoggedIn  }">
      <router-view :clickHelp="clickHelpVar" @updateNotis="clickUpdateNotis" :globalSearch="gsearch"/></div>
    <div id="footer">
      <Footer @clickHelp="clickHelp"/> 
    </div>
    
          <v-dialog v-model="dialog" width="500">

            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t("loginAgain") }}
              </v-card-title>
              <br />
              <v-card-text>
                <v-text-field
                v-model="current.email"
                :label="$t('email')">
                </v-text-field>
                <v-text-field
                v-model="current.password"
                :label="$t('password')"
                type="password">
                </v-text-field>
                <v-btn @click.prevent="login">{{$t('login')}}</v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>

          



  </v-app>
</template>

<script>
  import ApiService from '@/services/ApiService.js';
  import Footer from '@/views/Segments/Footer.vue'
  // import Menu from '@/views/Segments/Menu.vue'
  import NavBar from '@/views/Segments/Navbar.vue'

  export default {
    components: {
      Footer,
      // Menu,
      NavBar
    },
    name: 'app',
    data() {
      return {
        page: null,
        clickHelpVar:0,
        gsearch: "",
        searchvar: 0,
        dialog: false,
        current: {},
        updateNotis: 0
      }
    },
    async created(){
      this.longPolling()
      setInterval(this.longPolling, 120000)
    },
    methods: {
      async longPolling() {
        
        if (this.$router.currentRoute.fullPath !== "/login"  && this.$router.currentRoute.fullPath !== "/forgotPass") {
          let response = await ApiService.postInform()
          if(!response){
            this.$store.dispatch('doLogout');
              this.$router.push('/login');
            // this.handleOpenDialog()
          }
          if (response.status != 200) {
            this.$store.dispatch('doLogout');
              this.$router.push('/login');
            // this.handleOpenDialog()
            }else{
              this.$store.dispatch('setUser', response.data);
            }
        }
      },
      handleOpenDialog(){
        this.dialog = true;
      },
      searchClicked(search){
        this.searchvar++
        search = this.searchvar + " " + search
        console.log(search)
        this.gsearch = search
      },
      clickHelp(){
        this.clickHelpVar++
      },
      clickUpdateNotis(){
        this.updateNotis++
      },
      async login(){
          let response = await ApiService.postLogin({
            email: this.current.email,
            password: this.current.password
          });
          this.loading = false
          if (response.status == 200) {
            if(response.data.access_token != null){
            let token = response.data.access_token;
            let user = response.data.user;
            this.$store.dispatch('doLogin', { user, token });
            this.dialog = false
            }else{
              this.$swal(this.$t("error"), this.$t("errorBanned"), "error");
            }
          } else {
            response.data.error != null ? this.$swal(this.$t('error'), this.$t(response.data.error), 'error') : this.$swal(this.$t('error'), this.$t('errorMailOrPass'), 'error')
          }
      }
    },
    watch: {
      $route (to, from) {
        if(to.path.toLowerCase() != from.path.toLowerCase() && to.path.toLowerCase() != "/login" && to.path.toLowerCase() != "/forgotpass" && !to.path.toLowerCase().includes("/footer/")){
          !this.$store.getters.isLoggedIn ? this.$router.push("/login") : ""
        }
      },
    }
  }
</script>
<style lang="scss">
  @import "@/assets/scss/global.scss";
  #footer {
    max-height: 10%;
  }
</style>
